import no from "./no";
import en from "./en";

export default { no, en };
